import { Component } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../Model/Common/common.service';
import { TransferOrderToBranchService } from '../transfer-order-to-branch.service';
import { PostingOrderService } from '../posting-order.service';
import { TransferOrderService } from '../transfer-order.service';
import { SessionService } from '../Util/Session/session.service';
import { ComboService } from '../Model/Combo/combo.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { AllotmentDetailService } from '../allotment-detail.service';

@Component({
  selector: 'app-transfer-order-to-branch-form',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgSelectModule],
  templateUrl: './transfer-order-to-branch-form.component.html',
  styleUrl: './transfer-order-to-branch-form.component.scss'
})
export class TransferOrderToBranchFormComponent {

  LoadData: any[] = []
  BranchLoad: any[] = [];
  EmployeeLoad: any[] = [];
  CustomerLoad: any[] = [];
  LocationLoad: any[] = [];
  EmployeeDesignationLoad: any[] = [];
  TransferToBranchLoad: any[] = [];
  Remarks: any;

  isDisabled: boolean = false;
  user: any = {}
  IsSubContractor = false;
  Filter = {
    SelectType: 2,
    ID: null as any,
    TRANSACTIONDATE: null as any,
    BranchID: null as any,
    EMPLOYEEID: null,
    SelectedEmployee: '',
    FROM_CUSTOMERID: null as any,
    FROM_CUSTOMER: '',
    FROM_SITEID: null as any,
    FROM_SITE: '',
    TO_CUSTOMERID: null as any,
    TO_SITEID: null,
    FROMDATE: null as any,
    TODATE: null,
    REASONID: null,
    REMARKS: null,
    CREATEDBY: this.user.UserId,
    DESIGNATIONID: null,
    ALLOTMENTID: null,
    DUTYID: null,
    SHIFTID: null,
    Client: null as any,
    DesignationName: '',
    JoiningDate: null as any,
    VendorId: 0,
    VendorName: ''
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    public common: CommonService,
    private Transferordertootherbranch: TransferOrderToBranchService,
    private PostingOrder: PostingOrderService,
    private TransferOrder: TransferOrderService,
    private session: SessionService,
    private combo: ComboService,
    private allotmentService: AllotmentDetailService
  ) {
    this.IsSubContractor = window.location.pathname.includes('transferordertobranchsub');
    this.route.params.subscribe(params => this.Filter.ID = parseInt(params['id']));
    this.user = this.session.GetUserDetails();
    this.Filter.CREATEDBY = this.user.UserId;
  }

  async ngOnInit() {
    this.GetTodaysDate();
    await this.ComboLoad('Branch');
    if (this.Filter.ID > 0) {
      this.GetData();
    }
  }

  async GetData() {
    this.isDisabled = true;
    this.PostingOrder.PostingOrder({
      PostingOrderID: this.Filter.ID
    }).subscribe({
      next: async (response) => {
        const data = response.Table[0];
        this.Filter.ALLOTMENTID = data.PostingOrderNumber;
        this.Filter.TRANSACTIONDATE = data.TransactionDate.split('/')[2] + '-' + data.TransactionDate.split('/')[1] + '-' + data.TransactionDate.split('/')[0]
        this.Filter.FROMDATE = data.EffectDateFrom.split('/')[2] + '-' + data.EffectDateFrom.split('/')[1] + '-' + data.EffectDateFrom.split('/')[0]
        this.Filter.BranchID = data.BranchID;
        this.IsSubContractor ? await this.ESS_EmployeeSubcontracterSelect() : await this.FillCombo('Transfer Order To Other Branch', 0, data.PostingOrderID);
        console.log(this.EmployeeLoad);
        await this.FillCombo('Transfer Order To Other Branch', 1);
        this.Filter.EMPLOYEEID = data.EmployeeID;
        this.Filter.SelectedEmployee = data.EmployeeName;
        console.log(this.Filter.EMPLOYEEID);
        this.Filter.FROM_CUSTOMERID = data.PCustomerId;
        this.Filter.FROM_CUSTOMER = data.PCustomerName;
        this.Filter.FROM_SITEID = data.PSiteId;
        this.Filter.FROM_SITE = data.PSiteName;
        this.Filter.TO_CUSTOMERID = data.CustomerID;
        this.Filter.REMARKS = data.Remarks;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.combo.ComboLoad({
        'Combotype': Combotype,
        'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.BranchID : 0,
        'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.TO_CUSTOMERID : 0,
        'SiteId': (Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.TO_SITEID : 0,
        'DesignationId': (Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.DESIGNATIONID : 0,
        'DutyId': (Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.DUTYID : 0,
        'EmpType': 'Front'
      }).subscribe({
        next: (response) => {
          if (Combotype == 'Branch') {
            this.BranchLoad = response.ComboLoad
          }
          else if (Combotype == 'Site') {
            this.LocationLoad = response.ComboLoad;
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  GetDataOnEmployeeLoad(empId: any) {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.TransferOrder.GetDataOnComboLoad({
        SelectType: "Transfer Order To Other Branch",
        ID: empId,
      }).subscribe({
        next: (response) => {
          if (response.Table.length == 0) {
            this.Filter.SelectedEmployee = '';
            this.Filter.FROM_SITEID = '';
            this.Filter.FROM_CUSTOMERID = null;
            this.Filter.DESIGNATIONID = null;
            this.Filter.DUTYID = null;
            this.Filter.SHIFTID = null;
            this.Filter.VendorId = 0;
            this.Filter.VendorName = '';
            this.Filter.FROM_CUSTOMER = '';
            this.Filter.FROM_SITE = '';
          } else {
            const data = response.Table[0];
            this.Filter.SelectedEmployee = data.EmpName;
            this.Filter.FROM_SITE = data.SiteName;
            this.Filter.FROM_CUSTOMER = data.ClientGroupName;
            this.Filter.DesignationName = data.DesignationName;
            this.Filter.FROM_CUSTOMERID = data.ClientGroupMasterID;
            this.Filter.FROM_SITEID = data.SiteMasterID;
            this.Filter.JoiningDate = data.JoiningDate.split('/')[2] + '-' + data.JoiningDate.split('/')[1] + '-' + data.JoiningDate.split('/')[0];
            this.Filter.VendorId = this.EmployeeLoad.find((item: any) => item.EmpMasterID == this.Filter.EMPLOYEEID).VendorId;
            this.Filter.VendorName = this.EmployeeLoad.find((item: any) => item.EmpMasterID == this.Filter.EMPLOYEEID).VendorName;
            this.Filter.DESIGNATIONID = data.DesignationID;
            this.Filter.DUTYID = data.DutyId;
            this.Filter.SHIFTID = data.ShiftMasterID;
          }
          resolve(true);
          this.isDisabled = false;
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  // GetDataOnEmployeeLoad() {
  //   this.isDisabled = true;
  //   this.allotmentService.EmployeeAllotmentDetails({
  //     EmpMasterID: this.Filter.EMPLOYEEID,
  //   }).subscribe({
  //     next: (response) => {
  //       if (response.Table.length == 0) {
  //         this.Filter.SelectedEmployee = '';
  //         this.Filter.FROM_SITEID = '';
  //         this.Filter.FROM_CUSTOMERID = null;
  //         this.Filter.DESIGNATIONID = null;
  //         this.Filter.DUTYID = null;
  //         this.Filter.SHIFTID = null;
  //         this.Filter.VendorId = 0;
  //         this.Filter.VendorName = '';
  //         this.Filter.FROM_CUSTOMER = '';
  //         this.Filter.FROM_SITE = '';
  //       } else {
  //         const data = response.Table[0];
  //         this.Filter.SelectedEmployee = data.FullName;
  //         this.Filter.FROM_SITE = data.FromSiteName;
  //         this.Filter.FROM_SITEID = data.From_SiteID;

  //         this.Filter.FROM_CUSTOMER = data.FromClientName;
  //         this.Filter.FROM_CUSTOMERID = data.From_CustomerID;

  //         this.Filter.DesignationName = data.FromDesignationName;
          
  //         this.Filter.FROM_SITEID = data.From_SiteID;

  //         this.Filter.JoiningDate = data.JoiningDate.split('/')[2] + '-' + data.JoiningDate.split('/')[1] + '-' + data.JoiningDate.split('/')[0];
  //         this.Filter.VendorId = this.EmployeeLoad.find((item: any) => item.EmpMasterID == this.Filter.EMPLOYEEID).VendorId;
  //         this.Filter.VendorName = this.EmployeeLoad.find((item: any) => item.EmpMasterID == this.Filter.EMPLOYEEID).VendorName;
  //         this.Filter.DESIGNATIONID = data.FromDesignationID;
  //         this.Filter.DUTYID = data.FromDutyID;
  //         this.Filter.SHIFTID = data.FromShiftID;
  //       }
  //       this.isDisabled = false;
  //     },
  //     complete: () => {
  //       this.isDisabled = false;
  //     },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  GetTodaysDate() {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    this.Filter.TRANSACTIONDATE = formattedDate;
    this.Filter.FROMDATE = formattedDate;
  }

  async ESS_EmployeeSubcontracterSelect() {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.PostingOrder.ESS_EmployeeSubcontracterSelect({
        SubType: 'A',
        SelectType: 'EW'
      }).subscribe({
        next: async (response) => {
          this.EmployeeLoad = [...response.Table, response.Table.map((e: any) => e.Code = (e.FirstName + ' ' + e.LastName))];
          resolve(true);
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  FillCombo(Combotype: String, ID1: any = 0, ID2: any = 0) {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.PostingOrder.FillCombo({
        'SelectType': Combotype,
        'BranchID': this.Filter.BranchID,
        'UserID': 0,
        'ID1': ID1,
        'Code1': '',
        'ID2': ID2,
        'Code2': '',
        'ID3': '',
        'Code3': '',
        'EmpType': '',
        // 'EmpType': 'front'
      }).subscribe({
        next: (response) => {
          if (Combotype === 'Branch Master') {
            this.BranchLoad = response.Table
          } else if (Combotype === 'Max ERPBranchID Master') {
            this.EmployeeLoad = response.Table
          } else if (Combotype === 'Transfer Order To Other Branch' && ID1 == 1) {
            this.TransferToBranchLoad = response.Table
          } else if (Combotype === 'Transfer Order To Other Branch') {
            this.EmployeeLoad = response.Table;
          }
          resolve(true);
          this.isDisabled = false;
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  async OnBranchChange() {
    this.EmployeeLoad = [];
    this.IsSubContractor ? await this.ESS_EmployeeSubcontracterSelect() : await this.FillCombo('Transfer Order To Other Branch');
    this.FillCombo('Transfer Order To Other Branch', 1);
    this.Filter.EMPLOYEEID = null;
    this.Filter.SelectedEmployee = '';
    this.Filter.FROM_CUSTOMER = '';
    this.Filter.FROM_SITE = '';
  }

  Save() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you sure want to save?'
    modalRef.result.then((result: any) => {
      if (result) {
        this.Filter.SelectType = this.Filter.ID > 0 ? 61 : 6
        this.InsertUpdate();
      }
    }).catch(() => {

    });
  }

  InsertUpdate() {
    let joiningDate = new Date(this.Filter.JoiningDate);
    let transferDate = new Date(this.Filter.FROMDATE);

    if (joiningDate > transferDate) {
      alert(`Transfer Order Date should be greater than equal to ${this.Filter.JoiningDate}`);
      return;
    }

    this.Filter.TODATE = this.Filter.FROMDATE;
    this.isDisabled = true;
    this.TransferOrder.SaveTransferOrder(this.Filter).subscribe({
      next: (response) => {
        if (response.STATUS == 1) {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.IsSubContractor ? this.router.navigate(['/allocation/transferordertobranchsub']) : this.router.navigate(['/allocation/transferordertobranch']);
            }
          });
        } else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;

      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  TransferOrderToOtherBranchPrint() {
    this.isDisabled = true;
    this.Transferordertootherbranch.TransferOrderToOtherBranchReport({
      ID: this.Filter.ID,
      BranchID: this.Filter.BranchID
    }).subscribe({
      next: (response) => {
        window.open(response.FullFileName, '_blank')
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  cancel() {
    // console.log(this.IsSubContractor);
    this.IsSubContractor ? this.router.navigate(['/allocation/transferordertobranchsub']) : this.router.navigate(['/allocation/transferordertobranch']);
  }

}
